(function () {
  function init(root) {
    if (root.dataset.vtaReady === '1') return;
    root.dataset.vtaReady = '1';

    var track = root.querySelector('[data-vta-track]'),
        prev  = root.querySelector('[data-vta-prev]'),
        next  = root.querySelector('[data-vta-next]');

    if (!track || !prev || !next || !track.children.length) return;

    function gap() {
      var st = getComputedStyle(track);
      var g = parseFloat(st.columnGap || st.gap);
      return isNaN(g) ? 20 : g;
    }

    function step() {
      return track.children[0].getBoundingClientRect().width + gap();
    }

    function paint() {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);

    paint();
    requestAnimationFrame(paint);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(paint).catch(function () {});
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.vt-avis').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
